import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIndices } from "../api/FlaskAPI";
import { setIndices } from "../reducers/IndicesSlice";

// Loads the project's indices on mount; for any page that needs them
// so it works when opened directly (not only after the map).
export default function useIndices() {
  const dispatch = useDispatch();
  const indices = useSelector((state) => state.indices || []);

  useEffect(() => {
    const fetchIndices = async () => {
      try {
        const response = await getIndices();
        if (response && response.data) {
          dispatch(setIndices(response.data));
          localStorage.setItem("indices", JSON.stringify(response.data));
        }
      } catch (error) {
        console.error("Error fetching indices:", error);
        // Try to load from localStorage as fallback
        const storedIndices = localStorage.getItem("indices");
        if (storedIndices) {
          dispatch(setIndices(JSON.parse(storedIndices)));
        }
      }
    };

    fetchIndices();
  }, [dispatch]);

  return indices;
}
